<template>
  <div class="login-form-home sign-up-form text-left" >
    <div class="login-form-wrapper">
      <div class="bp-logo">
        <img src="@/assets/images/logos/BP.png" alt="logo">
        <p class="app-name">{{ $t('OUTER_PAGES.common.player')}}</p>
      </div>

      <div class="wrong-page text-align-left" v-if="!linkIsValid & pageLoaded && !redeemedLink">
        {{ $t('OUTER_PAGES.emailConfirm.notValid')}}
      </div>

      <div class="wrong-page text-align-left" v-if="notFound">
        {{ $t('OUTER_PAGES.common.notFound')}}
      </div>

      <div class="text-align-left" v-if="linkIsValid & pageLoaded && !redeemedLink">
        <i18n path="OUTER_PAGES.emailConfirm.confirmAndRedeem">
          <router-link slot="loginPage" class="link underline" :to="{ name: 'Login' }">Login page</router-link>
        </i18n>
      </div>
      
      <div class="text-align-left" v-if="redeemedLink & pageLoaded">
        <i18n path="OUTER_PAGES.emailConfirm.confirmAndRedeem">
          <router-link slot="loginPage" class="link underline" :to="{ name: 'Login' }">Login page</router-link>
        </i18n>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/common/api.service'
import { EMAIL_CONFIRMATION_URL } from '@/constants/ApiConstants'
import { ACTIVE } from '@/constants/UserStatuses'
import { UPDATE_ACCOUNT_STATUS, LOGOUT } from '@/store/action.types'
import { mapActions } from 'vuex'
import STATUS_CODES from '@/common/statusCodes'

export default {
  name: 'Signup',
  data () {
    return {
      pageLoaded: false,
      linkIsValid: false,
      redeemedLink: false,
      notFound : false
    }
  },
  computed: {
    confirmationToken: {
      get () {
        return this.$route.params.token
      }
    }
  },
  methods: {
    ...mapActions({
      updatePlayerStatus: UPDATE_ACCOUNT_STATUS,
      logoutAction: LOGOUT
    })
  },
  mounted () {
    ApiService.put(`${EMAIL_CONFIRMATION_URL.replace(':token', this.confirmationToken)}`)
      .then(response => {
        if(response.status.code === STATUS_CODES.BP_412) {
          this.pageLoaded = true
          this.redeemedLink = true
          this.logoutAction();
        } else if (response.status.code === STATUS_CODES.BP_404) {
          this.notFound = true
        } else if (response.status.code === STATUS_CODES.BP_405) {
          this.pageLoaded = true
        } else {
          this.pageLoaded = true
          this.linkIsValid = true
          this.updatePlayerStatus(ACTIVE)
        }
      })
      .catch((error) => {
        this.pageLoaded = true
      })
  }
}
</script>

